import React, { useState } from "react";
import { Link } from "react-router-dom";
import LoginComponent from "./LoginComponent.js";
import PasswordReset from "./PasswordReset.js";
import { motion } from "framer-motion";

const LoginPage = () => {
  const [isPasswordResetOpen, setPasswordResetOpen] = useState(false);
  const togglePasswordReset = () => setPasswordResetOpen(!isPasswordResetOpen);

  return <LoginComponent />;
};
export default LoginPage;
